// src/components/Blocks/CAMEvents/Schema.js

const CAMEventsSchema = {
  title: 'CAM Events',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['title'],
    },
  ],
  properties: {
    title: {
      title: 'Block Title',
      type: 'string',
      description: 'Optional title for the events block',
    },

    },
  required: [],
};

export default CAMEventsSchema;
